// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--1ewHF","h1":"about-module--h1--2zlzQ","secondaryText":"about-module--secondaryText--314BQ"};